// export const javaEndPoint = 'http://10.0.1.2:8001'//庞
// export const javaEndPoint  = 'http://10.10.49.187:9123'  //测试

// export const javaWs = "ws://10.0.1.2:8001/websocket/"

const userType = "operator" // 用户类型 operator：运营商端 supervision：治理端
const appId = process.env.VUE_APP_APPID
const ssoUrl = process.env.VUE_APP_SSOURL
export const redirectUrl = `${ssoUrl}?userType=${userType}&appId=${appId}`